import React from 'react';
import { motion } from 'framer-motion';

const Reveal = ({ children, delay = 0, y = 24, as = 'div', className = '', once = true }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.25 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
